import React, { useState } from "react";
import Box from "@mui/material/Box";
import { Tab, Tabs } from "@mui/material";

import General from "./General";
import Communication from "./Communication";
import Payment from ".//Payment";
import AgreementLevel from "./AgreementLevel";
import StandardTerms from "./StandardTerms";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

export function ClientForm({
  formData,
  FORM_MODE,
  handleInputChange,
  countryCodes,
  languageCodes,
  services,
  paymentMethods,
  agreementOptions,
  boolOptions,
}) {
  const [tabIndex, setTabindex] = useState(0);

  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={handleTabSwitch}
        sx={{ marginBottom: "2rem" }}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="Allmänt" />
        <Tab label="Kommunikation" />
        <Tab label="Betalning" />
        <Tab label="Avtal" />
        <Tab label="Villkor" />
      </Tabs>
      <TabPanel value={tabIndex} index={0}>
        <General
          client={formData}
          FORM_MODE={FORM_MODE}
          countryCodes={countryCodes}
          handleInputChange={handleInputChange}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <Communication
          client={formData}
          FORM_MODE={FORM_MODE}
          languageCodes={languageCodes}
          handleInputChange={handleInputChange}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <Payment
          client={formData}
          FORM_MODE={"LOCKED"}
          paymentMethods={paymentMethods}
          handleInputChange={handleInputChange}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={3}>
        <AgreementLevel
          client={formData}
          services={services}
          handleInputChange={handleInputChange}
          boolOptions={boolOptions}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={4}>
        <StandardTerms
          client={formData}
          handleInputChange={handleInputChange}
          agreementOptions={agreementOptions}
          boolOptions={boolOptions}
        />
      </TabPanel>
    </>
  );
}
